export default [
  {
    path: '/elaboracao/consulta',
    name: 'consultarElaboracao',
    component: () => import(/* webpackChunkName: "elaboracao-consulta" */ './consultarElaboracao.vue')
  }
]
